import { z } from 'zod';

export const DescriptionMaxLength = 10000; // Matches limit in legacy fim

export const LifecycleFilter = {
  Active: 'active',
  All: 'all',
  Archived: 'archived',
  Deleted: 'deleted',
  Stale: 'stale',
} as const;

export type LifecycleFilterType = (typeof LifecycleFilter)[keyof typeof LifecycleFilter];

export const LifecycleFilterSchema = z.nativeEnum(LifecycleFilter);

export const DeleteMode = {
  Soft: 'soft',
  Hard: 'hard',
  Undelete: 'undelete',
};
export type DeleteModeType = (typeof DeleteMode)[keyof typeof DeleteMode];

export const DeleteModeSchema = z.nativeEnum(DeleteMode);

export const SortSchema = z.object({
  column: z.string(),
  order: z.enum(['asc', 'desc']),
  collate: z.boolean().optional(),
});

export type SortDto = z.infer<typeof SortSchema>;

export const GetAllParams = z.object({
  includeDeleted: z.boolean().optional(),
  lifecycleFilter: LifecycleFilterSchema.optional(),
  search: z.string().optional(),
  offset: z.number().min(0).optional(),
  limit: z.number().min(1).optional(),
  pageSize: z.number().min(1).max(100).optional(),
  sort: SortSchema.optional(),
});

export type GetAllParamsDto = z.infer<typeof GetAllParams>;

export const ItemId = z.object({
  id: z.number(),
});

export type ItemIdDto = z.infer<typeof ItemId>;

export const withFallback = <T>(schema: z.ZodType<T>, fallback: T) =>
  z.preprocess(
    (value) => {
      const parseResult = schema.safeParse(value);
      if (parseResult.success) return value;
      return fallback;
    },
    z.custom<T>((v) => {
      void v;
      return true;
    }),
  );
